import { memo } from "react";
import { NotificationBadge } from "@/shared/components/NotificationBadge";
import { useAdminNotificationsContext } from "@/shared/contexts/AdminNotificationsProvider";

export const FormSubmissionCounter = memo(() => {
  const { counts } = useAdminNotificationsContext();
  return <NotificationBadge count={counts.submissions_pending} />;
});

FormSubmissionCounter.displayName = "FormSubmissionCounter";
